cdb.config.set('assets_url', '//cartodb-libs.global.ssl.fastly.net/cartodbui/assets/4.6.99');
console.log('cartodbui v4.6.99');